import { Component, Input } from '@angular/core';

export interface DetailsEmptyMoskImg {
  img: string;
  text: string;
}

@Component({
  selector: 'bz-empty-mosk-img',
  templateUrl: './bz-empty-mosk-img.component.html',
  styleUrls: ['./bz-empty-mosk-img.component.sass']
})
export class BzEmptyMoskImgComponent {

  @Input() public img: string;
  @Input() public text: string;
  @Input() public details: DetailsEmptyMoskImg[];
  @Input() public description: string;

}
